import React from "react";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;
  return (
    <footer className="bg-header-black flex-col text-white font-sans pt-27 page-footer">
      <div className="flex flex-row justify-start gap-12 p-footer border-b">
        <div className="footer__container mr-10">
          <img src="../Images/ctic-logo-white.bf83e0e3.svg" alt="CTIC Logo" />
        </div>
        <div className="footer__container">
          <p> {t("mainAddressFooterHeading")}</p>
          <p> 100 – 55 Superior Boulevard</p>
          <p> Mississauga, Ontario</p>
          <p> L5T 2X9</p>
          <p> {t("headOfficeHours")}</p>
          <p> {t("phone")} 289-562-5216 / 1-888-868-4853</p>
          <p> {t("fax")} 289-562-2478 / 1-866-214-1953</p>
          <p>
            {" "}
            {t("emaill")}{" "}
            <a
              href="mailto:info@chicagotitle.ca"
              className="underline focus-visible:outline-none focus:outline-none text-shadow "
            >
              info@chicagotitle.ca
            </a>
          </p>
        </div>
        <div className="footer__container">
          <p> {t("quebecAddressFooterHeading")}</p>
          <p> {t("quebecAddressLine1")}</p>
          <p> {t("quebecAddressLine2")}</p>
          <p> Westmount, Quebec</p>
          <p> H3Z 2P9</p>
          <p> {t("quebecOfficeHours")}</p>
          <p> {t("phone")} 1-877-849-3113</p>
          <p> {t("fax")} 1-877-339-3773</p>
          <p>
            {" "}
            {t("emaill")}{" "}
            <a
              href="mailto:info@ctic.ca"
              className="underline focus-visible:outline-none focus:outline-none text-shadow "
            >
              info@ctic.ca
            </a>
          </p>
        </div>
        <div className="footer__container mr-4">
          <p>
            {" "}
            Complaints:{" "}
            <a
              href={
                currentLanguage == "en"
                  ? "https://chicagotitle.ca/wp-content/uploads/CTIC_Complaint_Processing_Resolution_Policy_072025_EN_AODA.pdf"
                  : "https://chicagotitle.ca/wp-content/uploads/CTIC_Complaint_Processing_Resolution_Policy_072025_FR_AODA.pdf"
              }
              target="_blank"
              className="underline focus-visible:outline-none focus:outline-none text-shadow"
            >
              {t("complaints")}
            </a>
          </p>
          <p>
            {" "}
            {t("claims")}
            <a
              href={
                currentLanguage == "en"
                  ? "https://chicagotitle.ca/submit-claim"
                  : "https://chicagotitle.ca/fr/soumettre-reclamation"
              }
              className="underline focus-visible:outline-none focus:outline-none text-shadow"
            >
              {t("claimsText")}
            </a>
          </p>
        </div>
        <div className="footer__container ">
          <a
            // className=" focus-visible:outline-none focus:outline-none text-shadow"
            className="underline focus-visible:outline-none focus:outline-none text-shadow"
            href={
              currentLanguage == "en"
                ? "https://chicagotitle.ca/"
                : "https://chicagotitle.ca/fr/accueil"
            }
          >
            {t("helpText")}
          </a>
        </div>
      </div>

      <div className="footer__copyright flex justify-between font-sans p-fc-x">
        <div className="footer__container pl-50 pb-100">
          <p>
            Copyright © 2020 Chicago Title Insurance Company. All Rights
            Reserved
          </p>
        </div>
        <div className="footer__container pr-8">
          <p>
            <a
              className=" focus-visible:outline-none focus:outline-none text-shadow"
              href={
                currentLanguage == "en"
                  ? "https://chicagotitle.ca/accessibility-policy"
                  : "https://chicagotitle.ca/fr/politique-daccessibilite"
              }
            >
              {t("accessibility")}{" "}
            </a>
            |{" "}
            <a
              className=" focus-visible:outline-none focus:outline-none text-shadow"
              href={
                currentLanguage == "en"
                  ? "https://chicagotitle.ca/terms-of-use"
                  : "https://chicagotitle.ca/fr/conditions-dutilisation"
              }
            >
              {t("termsOfUse")}{" "}
            </a>
            |{" "}
            <a
              className=" focus-visible:outline-none focus:outline-none text-shadow"
              href={
                currentLanguage == "en"
                  ? "https://chicagotitle.ca/privacy-policy"
                  : "https://chicagotitle.ca/fr/confidentialite"
              }
            >
              {t("privacyPolicy")}{" "}
            </a>
            |{" "}
            <a
              className=" focus-visible:outline-none focus:outline-none text-shadow"
              href="https://fnf.com/california-privacy"
            >
              {t("CaPrivacyPolicy")}{" "}
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default React.memo(Footer);
